import { createContext, useState } from "react";
import { getLocalStorage } from "../services/StorageHelper";

export const CookieConsentContext = createContext(null);

export function CookieConsentProvider({ children }) {
  const [cookieConsentMode, setCookieConsentMode] = useState(
    () => getLocalStorage("cookieConsentModeV2", null)
  );

  return (
    <CookieConsentContext.Provider value={{ cookieConsentMode, setCookieConsentMode }}>
      {children}
    </CookieConsentContext.Provider>
  );
}
